<r-widget-control [control]="firstnameControl">
  <nz-date-picker
    [name]="config.name"
    [nzPlaceHolder]="config.placeholder"
    [nzAllowClear]="config.allowClear"
    [ngModel]="config.value | datePipe"
    (ngModelChange)="onChange($event)"
    [nzFormat]="dateFormat"
    [required]="config.required"
    [disabled]="config.disabled"
    ngDefaultControl
    #firstnameControl="ngModel"
    style="width: 100%"
  ></nz-date-picker>
</r-widget-control>
